import axios from 'axios';
import store from './store/store';
import NProgress from 'nprogress';

export default () => {
  // conto le richieste in coda
  let pendingRequests = 0;

  axios.interceptors.request.use(
    config => {
      config.headers['Authorization'] = `Bearer ${store.getters.jwt}`;
      config.headers['Cache-Control'] = `no-cache`;

      // incremento le richieste in coda
      pendingRequests++;
      // visualizzo il loader
      NProgress.start();
      return config;
    },

    error => {
      return Promise.reject(error);
    },
  );

  axios.interceptors.response.use(
    response => {
      // decremento le richieste in coda
      pendingRequests--;
      if (!pendingRequests) {
        // rimuovo il loader
        NProgress.done();
      }
      if (response.error) {
        return Promise.reject(response.error);
      } else {
        return response;
      }
    },
    error => {
      // rimuovo il loader
      pendingRequests = 0;
      NProgress.done();
      if (error.response === undefined) {
        store.commit('errorsModule/HANDLE_ERROR', {
          show: true,
          message: 'Errore di comunicazione col server. Riprovare',
        });
      } else if (error.response.status === 500 && !error.response.data.message != undefined) {
        let errors = '<ul>';
        if (Array.isArray(error.response.data.message)) {
          error.response.data.message.forEach(element => {
            Object.keys(element.constraints).forEach(key => {
              errors += '<li>' + element.constraints[key] + '</li>';
            });
          });
        } else {
          errors += '<li>' + error.response.data.message + '</li>';
        }
        errors += '</ul>';
        store.commit('errorsModule/HANDLE_ERROR', {
          show: true,
          message: errors,
        });
      } else if (error.response.data.statusCode === 401) {
        // visualizzo box errore
        store.commit('errorsModule/HANDLE_ERROR', {
          show: true,
          message: 'Sessione scaduta. Effettuare il login',
        });
        window.getApp.$emit('APP_UNAUTHORIZED');
      } else if (error.response.data.message.message) {
        let errors = '<ul>';
        if (Array.isArray(error.response.data.message.message)) {
          error.response.data.message.message.forEach(element => {
            Object.keys(element.constraints).forEach(key => {
              errors += '<li>' + element.constraints[key] + '</li>';
            });
          });
        } else {
          errors += '<li>' + error.response.data.message.message + '</li>';
        }
        errors += '</ul>';
        // visualizzo box errore
        store.commit('errorsModule/HANDLE_ERROR', {
          show: true,
          message: errors,
        });
      } else if (error.response.data.message) {
        let errors = '<ul>';
        if (Array.isArray(error.response.data.message)) {
          error.response.data.message.forEach(element => {
            Object.keys(element.constraints).forEach(key => {
              errors += '<li>' + element.constraints[key] + '</li>';
            });
          });
        } else {
          errors += '<li>' + error.response.data.message + '</li>';
        }
        errors += '</ul>';
        // visualizzo box errore
        store.commit('errorsModule/HANDLE_ERROR', {
          show: true,
          message: errors,
        });

      } else {
        // visualizzo box errore
        store.commit('errorsModule/HANDLE_ERROR', {
          show: true,
          message: error.response.data.message,
        });
      }
      return Promise.reject(error);
    },
  );
};